import { ForwardRefExoticComponent, PropsWithChildren } from 'react'
import { createPathComponent, LeafletContextInterface, PathProps } from '@react-leaflet/core'

import L, { MarkerCluster, MarkerClusterGroup as LFMarkerClusterGroup } from 'leaflet'
import 'leaflet.markercluster'

interface PathWithChildrenProps extends PropsWithChildren<PathProps> {
  iconCreateFunction?: (cluster: MarkerCluster) => {}
}

const createClusterGroup = ({ children: _c, ...props }: PathWithChildrenProps, context: LeafletContextInterface) => {
  const clusterProps: { [key: string]: any } = {}
  const clusterEvents: { [key: string]: any } = {}

  // Splitting props and events to different objects
  Object.entries(props).forEach(([propName, prop]) =>
    propName.startsWith('on') ? (clusterEvents[propName] = prop) : (clusterProps[propName] = prop)
  )

  // Creating markerClusterGroup Leaflet element
  const instance: LFMarkerClusterGroup = L.markerClusterGroup(clusterProps)

  // Initializing event listeners
  Object.entries(clusterEvents).forEach(([eventAsProp, callback]) => {
    const clusterEvent = `cluster${eventAsProp.substring(2).toLowerCase()}`
    instance.on(clusterEvent, callback)
  })

  return {
    instance,
    context: { ...context, layerContainer: instance }
  }
}

const updateClusterGroup = (instance: LFMarkerClusterGroup) => {
  instance.refreshClusters()
}

export const MarkerClusterGroup: ForwardRefExoticComponent<PathWithChildrenProps> = createPathComponent(
  createClusterGroup,
  updateClusterGroup
)
